import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import Socail from './Socail'

function Welcome() {

    return (
        <div className="parallax">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <Navbar/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-11 col-sm-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-7 offset-md-2 pt-6 mt-4">
                                <h5 className="grey-text ff-mono">
                                WELCOME TO KAROT
                                </h5>
                            </div>
                            <div className="col-sm-12 col-md-7 offset-md-2">
                                <h1 className="bold white-text" style={{fontSize: '4rem'}}>We are a creative group of people who design and develop brands that inspires.</h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-12">
                            <Socail/>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-sm-12 col-md-7 offset-md-2">
                        <div className="btn-home center ff-mono bold"><a>START A PROJECT</a></div>
                        <div className="btn-home center ff-mono bold"><a>MORE ABOUT US</a></div>
                    </div>
                </div>
            </div>
            <div className="home-content__line">
            </div>
        </div>
    )
}

export default Welcome;